import { AxiosInstance } from 'axios';
import { Appointment } from 'components/_temp_ui_common/Appointments/types';
import { useMutation, useQueryClient } from 'react-query';

import { QueryKeys } from '../QueryKeys';
import { getAppointmentsParams } from './getAppointments';
import { updateAppointment } from './updateAppointment';

export type AppointmentUpdateParams = Partial<
  Omit<Appointment, 'id' | 'createdAt' | 'updatedAt'>
>;

export const useUpdateAppointment = (
  appointmentId: string,
  axiosInstance: AxiosInstance,
) => {
  const queryClient = useQueryClient();

  return useMutation(
    QueryKeys.updateAppointment(appointmentId),
    async (params: AppointmentUpdateParams) => {
      const result = await updateAppointment(
        axiosInstance,
        appointmentId,
        params,
      );

      (['iop', 'np', 'core'] as getAppointmentsParams['program'][]).forEach(
        program => {
          queryClient.invalidateQueries(
            QueryKeys.appointments(result.memberId, { program }),
          );
        },
      );

      return result;
    },
  );
};
